import { Entity } from '@decahedron/entity';

export default class Property extends Entity {
    public id: number = null;

    public name: number = null;
}
